module.exports = "https://cdn-skillquest.mathletics.com/app/180/assets/fonts/9bd029da4737382f43eec132079fddce.woff2";